import { trackUserLoggedIn } from "@/features/analytics/trackers";
import type { Authorize } from "@/shared/domains/auth/models";
import type { User } from "@/shared/domains/users";
import { authStore, useSettingsStore } from "@/shared/stores";

export const useHandleLogin = (email?: User["email"]) => {
  const setLanguage = useSettingsStore((state) => state.setLanguage);

  const handleLogin = ({ accessToken, preferredLanguage }: Authorize) => {
    authStore.setToken(accessToken);
    setLanguage(preferredLanguage);

    if (email) {
      trackUserLoggedIn({ userEmail: email });
    }
  };

  return { handleLogin };
};
